import * as Immutable from 'immutable'
import { SprocketAsset, AssetOutput, AssetsOutput } from '../types/types';

export const ToDictionary = <K extends {[_:string] : SprocketAsset}>(routeInputs : AssetOutput<K>[]) : AssetsOutput<K> =>  {
  return Immutable.List(routeInputs).
    groupBy<keyof K>(x => x.identifier).
    map(x => x.first()).
    map<AssetOutput<K>>(x => {
      return {
        url: x.url,
        identifier: x.identifier
      }
    }).toMap()
}
